package api

sealed class LanguageType(
    val title: String,
    val short: List<String>,
    val directoryName: String,
    val type: String = short.first(),
    val code: Int = type[0].code * 100 + type[1].code
) {
    data object English : LanguageType("English", listOf("en", "gb"), "values")
    data object Slovak : LanguageType("Slovenčina", listOf("sk"), "values-sk")
    data object Czech : LanguageType("Čeština", listOf("cs", "cz"), "values-cs")
    data object Hrvatska : LanguageType("Hrvatski", listOf("hr"), "values-hr")
    data object Bosnia : LanguageType("Bosanski", listOf("ba", "bs"), "values-ba")
    data object Bulgarian : LanguageType("Български", listOf("bg"), "values-bg")
    data object German : LanguageType("Deutsch", listOf("de"), "values-de")
    data object Spanish : LanguageType("Español", listOf("es"), "values-es")
    data object Italian : LanguageType("Italiano", listOf("it"), "values-it")
    data object French : LanguageType("Français", listOf("fr"), "values-fr")
    data object Portuguese : LanguageType("Português", listOf("pt"), "values-pt")

    companion object {
        val all by lazy {
            listOf(English, Slovak, Czech, Hrvatska, Bosnia, Bulgarian, German, Spanish, Italian, French, Portuguese)
        }

        /**
         * Finds language by code. Accepts BCP 47 tags as sent by browsers
         * (e.g. "cs-CZ", "en_GB", "bs-Latn-BA") — only the primary subtag is compared.
         */
        fun find(lang: String): LanguageType? {
            val primary = lang.trim().lowercase().split('-', '_').first()
            if (primary.isEmpty()) return null
            return all.firstOrNull { it.short.any { it == primary } }
        }

        operator fun get(lang: String): LanguageType {
            return find(lang) ?: English
        }
    }
}
